import { createCookie } from '../../../ts/utils/cookie.ts';

createCookie('JE_OA', '', {
  domain: 'jobrapido.com',
});
